import { compare } from 'compare-versions';

// in case of MM-E-PM device with FW version >= 4.3
// pulse value need to be set to 10 for properly displaying meterStatus value
export const getPMPulseValue = (fw: string) =>
  compare(fw, '4.3', '>=') ? 10 : 1;
